import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { useContextMenuClassNames } from './hooks/useContextMenuClassNames';
import { useContextMenu } from './hooks/useContextMenu';
import { ContextMenuRoot, ContextMenuArrow } from './style';
import { CONTEXTMENU_CLASS_PREFIX } from './constants';
import { MenuElement } from '../Menu';
import { PortalToBody } from '../../system/util/PortalToBody';
export var ContextMenu = forwardRef(function ContextMenu(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(CONTEXTMENU_CLASS_PREFIX);
  var classNameComponents = useContextMenuClassNames(CONTEXTMENU_CLASS_PREFIX, className);

  var _useContextMenu = useContextMenu(props, ref),
      portalProps = _useContextMenu.portalProps,
      rootProps = _useContextMenu.rootProps,
      arrowProps = _useContextMenu.arrowProps,
      trigger = _useContextMenu.trigger,
      open = _useContextMenu.open,
      displayChildren = _useContextMenu.displayChildren,
      displayMenuElements = _useContextMenu.displayMenuElements,
      menuElements = _useContextMenu.menuElements,
      children = _useContextMenu.children;

  return React.createElement(React.Fragment, null, trigger, open && React.createElement(PortalToBody, Object.assign({}, portalProps), React.createElement(ContextMenuRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNameComponents.Root
  }), React.createElement(ContextMenuArrow, Object.assign({
    theme: theme,
    className: classNameComponents.Arrow
  }, arrowProps)), displayChildren && children, displayMenuElements && menuElements.map(function (_ref2) {
    var id = _ref2.id,
        label = _ref2.label,
        elementProps = _ref2.props;
    return React.createElement(MenuElement, Object.assign({}, elementProps, {
      key: id,
      small: true
    }), label);
  }))));
});
ContextMenu.defaultProps = {
  align: 'bottom'
};